require('new_design/common/camps/show/maps');
